import { getPathAfterRoot, } from '@sudoplatform-private/admin-web-utils';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
export const useNotifySubAppOnNavigate = (onContainerNavigate, rootPath) => {
    const { pathname, search } = useLocation();
    /**
     * Returns the pathname provided by useLocation, except when the pathname
     * equals the rootPath we append a trailing '/'. This helps keep the Container
     * path (absolute) in sync with the Sub App path (relative).
     *
     * If this is not present, the Sub App will properly navigate to root ('/'),
     * which will cause the Container to navigate again. This sets off a cycle where
     * Container can never catch up to the Sub App.
     */
    const currentPathname = useMemo(() => {
        return pathname === rootPath ? pathname + '/' : pathname;
    }, [pathname, rootPath]);
    useEffect(() => {
        // Prevents attempting to navigate sub app if ACW is navigating to a different module
        if (!currentPathname.includes(rootPath))
            return;
        const nextPath = getPathAfterRoot(currentPathname, rootPath);
        onContainerNavigate?.(nextPath + search);
    }, [currentPathname, search, rootPath, onContainerNavigate]);
};
